import request from "@/utils/request";

// 移动端登录
export function appLogin(data) {
  return request({
    url: "/app/login",
    method: "post",
    data,
  });
}
// 查看投标项目列表 未报价
export function appBidList(data) {
  return request({
    url: "/app/crm/bid/appBidList",
    method: "post",
    data,
  });
}
// 查看投标项目详情 未报价
export function getBid(id) {
  return request({
    url: "/app/crm/bid/getBid",
    method: "get",
    params: { id },
  });
}
// 查看投标项目列表 已报价
export function bidQuotePage(data) {
  return request({
    url: "/app/bid/quote/customer/bidQuotePage",
    method: "post",
    data,
  });
}
// 查看投标项目详情 已报价
export function getQuote(params) {
  return request({
    url: "/app/bid/quote/customer/get",
    method: "get",
    params,
  });
}
// 报价单下单
export function saveOrUpdateQuote(data) {
  return request({
    url: "/app/bid/quote/customer/saveOrUpdate",
    method: "post",
    data,
  });
}
// 取消报价
export function deleteByCustomerBidId(id) {
  return request({
    url: "/app/bid/quote/customer/deleteById",
    method: "post",
    data:{id},
  });
}